import React from 'react';
import Type from 'prop-types';
import { ListItem, ListItemText, Typography } from '@material-ui/core';
import { ru } from 'locale';
import useStyles from './CaseSide.styles';

const CaseSide = props => {
  const classes = useStyles();
  const { sideName, organizations } = props;
  const title = organizations.length > 1 ? `${sideName}s` : sideName;

  const renderListOfOrganizations = () => {
    return organizations.map(organization => {
      return (
        <span key={organization.inn} className={classes.organization}>
          <Typography component="span" variant="body1">
            {organization.name}
          </Typography>
          <Typography component="span" variant="body2">
            {` \u2014 ${ru.inn}: ${organization.inn}`}
          </Typography>
        </span>
      );
    });
  };

  return (
    <ListItem component="div">
      <ListItemText primary={ru[title]} secondary={renderListOfOrganizations()} />
    </ListItem>
  );
};

CaseSide.propTypes = {
  sideName: Type.string.isRequired,
  organizations: Type.arrayOf(
    Type.shape({
      name: Type.string.isRequired,
      inn: Type.string.isRequired,
      side: Type.string.isRequired,
    }),
  ),
};

CaseSide.defaultProps = {
  organizations: [],
};

export default CaseSide;
